
export const SET_USER_REGISTERED = "SET_USER_REGISTERED";
export const SET_LOADING = "SET_LOADING";
export const SET_USER_LIST = "SET_USER_LIST";
export const SET_USER_LOGIN = "SET_USER_LOGIN";
export const SET_USER_DATA = "SET_USER_DATA";


